import color from 'color'
import * as d3 from 'd3'

import type { ConfusionMatrixChartData } from '../components/ConfusionMatrix/ChartConfusionMatrix'
import type { ConfusionMatrixInputData } from '../components/ConfusionMatrix/ConfusionMatrix'

export const prepareConfusionMatrixData = (
  inputData: ConfusionMatrixInputData
): ConfusionMatrixChartData => ({
  labels: inputData.classLabels,
  data: inputData.matrix
    .map((r, i) =>
      r.map((d, k) => ({
        y: inputData.classLabels[i],
        x: inputData.classLabels[k],
        value: d,
        total: r.reduce((a, b) => a + b, 0),
      }))
    )
    .flat(),
})

export const getRectColor = (d: ConfusionMatrixChartData['data'][0]) => {
  if (d.x !== d.y) {
    return {
      bg: '#efefef',
      text: '#cf2222',
    }
  }
  const bgColor = color(
    d3
      .scaleLinear()
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      .range(['#d1e3d1', '#1b4a1b'])
      .domain([0, d.total])(d.value)
  )

  return {
    bg: bgColor.rgb().string(),
    text: bgColor.isDark() ? '#ffffff' : '#155c15',
  }
}
